import { BodyLink, Caption, mq, theme } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import Link from '~/App/shared/components/Link';
import { BlockButtonRecord } from '~/config/generated/graphql';
import { Image } from 'react-datocms';
import AiGeneratedImageWrapper from '~/App/components/DatoCMS/AiGeneratedImageWrapper';

const PuffsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;

  ${mq(null, 'tablet')} {
    flex-direction: column;
  }
`;

const Puff = styled(Link)`
  display: grid;
  grid-template-columns: 30% auto;
  border-radius: 0.5rem;
  overflow: hidden;
  transition: box-shadow 0.3s;
  background-color: ${theme.colors.background.light};

  :hover {
    box-shadow: ${theme.elevations.elevation2};
  }

  ${mq('tablet')} {
    grid-template-columns: 100%;
  }

  img {
    aspect-ratio: 1;

    ${mq('tablet')} {
      aspect-ratio: 232/137;
    }
  }
`;

const TextContainer = styled.div`
  padding: 1rem;
  color: ${theme.colors.text.dark};

  ${mq('mobileM')} {
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  ${mq(null, 'tablet')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

type Props = { blockButtons?: BlockButtonRecord[] };

const FeatureBlocksItems = ({ blockButtons }: Props) => {
  return (
    <PuffsContainer>
      {blockButtons?.map((block, index) => {
        if (!block.backgroundImage?.responsiveImage?.src) return null;

        return (
          <Puff key={`${block.id}-${index}`} to={block.linkUrl}>
            <AiGeneratedImageWrapper tags={block.backgroundImage?.tags}>
              <Image
                data={{
                  ...block.backgroundImage?.responsiveImage,
                  aspectRatio: undefined
                }}
                objectFit="cover"
              />
            </AiGeneratedImageWrapper>
            <TextContainer>
              <BodyLink>{block.title}</BodyLink>
              <Caption>{block.preamble}</Caption>
            </TextContainer>
          </Puff>
        );
      })}
    </PuffsContainer>
  );
};

export default FeatureBlocksItems;
